import { useMutation } from '@tanstack/react-query'
import { useEffect, useRef } from 'react'

import { authAPI } from '@/api/new-api'
import { toastFactory } from '@/factories'
import { downloadHref, getApiErrorMessage } from '@/utils'

export interface ExportResidentParkingsRequest {
  fileName: string
  buildingId: number
}

export const exportResidentParkings = async (buildingId: number) => {
  const response = await authAPI.get<Blob>('/parking/csv', {
    params: { buildingId },
    responseType: 'blob',
  })
  return response.data
}

export const useExportResidentParkings = () => {
  const objectUrlRef = useRef<string | null>(null)

  const mutation = useMutation({
    mutationFn: async ({ fileName, buildingId }: ExportResidentParkingsRequest) => {
      const blob = await exportResidentParkings(buildingId)
      if (objectUrlRef.current) URL.revokeObjectURL(objectUrlRef.current)
      objectUrlRef.current = URL.createObjectURL(blob)
      downloadHref(objectUrlRef.current, fileName)
      return objectUrlRef.current
    },
    onError: (error) => {
      toastFactory.error(getApiErrorMessage(error))
    },
  })

  // Note: Clean up the URL object when the hook unmounts
  useEffect(() => {
    return () => {
      if (objectUrlRef.current) URL.revokeObjectURL(objectUrlRef.current)
    }
  }, [])

  return mutation
}
